import React from "react";
import logo from "../assets/img/logo.svg";
import prev_arrow from "../assets/img/prev_arrow.svg";
import next_arrow from "../assets/img/next_arrow.svg";

const Step7 = ({ setStep, setFormdata, formData,setStep7Status }) => {

  const Next=()=>{
    setStep7Status(true)
    console.log(formData)
    if(formData.is_email){
      setStep(7.1)
    }else if(formData.is_sms){
      setStep(7.2)
    }else{
      setStep(7.3)
    }
   
  }

  return (
    <>
      {/* <section class="step_wrapper"> */}
        <div class="top_logo_block">
          <div class="logo">
            <a href="">
              <img src={logo} alt="" />
            </a>
          </div>
        </div>

        <div class="step_body">
          <div class="step_form">
            <div class="form_block box_width_md_two">
              <h1>What is your preferred communication channel?</h1>
              <div class="chk_items chk_items_type_two">
                
                <div
                  class="item"
                  onClick={() =>
                    setFormdata((prevState) => ({
                      ...prevState, // Keep all other fields the same
                      is_email: true, // Update the name field
                      isLinkedin: null,
                      is_sms: null,
                    }))
                  }
                >
                  <input
                    type="radio"
                    name="contact_info"
                    checked={formData?.is_email}
                  />
                  <div class="check_ui">
                    <span>Email</span>
                  </div>
                </div>

                <div
                  class="item"
                  onClick={() =>
                    setFormdata((prevState) => ({
                      ...prevState, // Keep all other fields the same
                      is_email: null, // Update the name field
                      isLinkedin: null,
                      is_sms: true,
                    }))
                  }
                >
                  <input
                    type="radio"
                    name="contact_info"
                    checked={formData?.is_sms}
                  />
                  <div class="check_ui">
                    <span>Text</span>
                  </div>
                </div>

                <div
                  class="item"
                  onClick={() =>
                    setFormdata((prevState) => ({
                      ...prevState, // Keep all other fields the same
                      is_email: null, // Update the name field
                      isLinkedin: true,
                      is_sms: null,
                    }))
                  }
                >
                  <input
                    type="radio"
                    name="contact_info"
                    checked={formData?.isLinkedin}
                  />
                  <div class="check_ui">
                    <span>Linkedin</span>
                  </div>
                </div>

              </div>
            </div>
            <div class="btn_block">
              <a onClick={() => setStep(6)}>
                {" "}
                <img src={prev_arrow} alt="" /> <span>Prev</span>{" "}
              </a>
              <a onClick={() => Next()} class="nxt_btn">
                {" "}
                <span>next</span> <img src={next_arrow} alt="" />
              </a>
            </div>
          </div>
        </div>

        {/* <div class="bottom_steps">
        <ul class="for_desktop">
            <li onClick={()=>setStep(1)} >
              <span>Referrals</span>
            </li>
            <li onClick={()=>setStep(2)} >
              <span>Your details</span>
            </li>
            <li onClick={()=>setStep(3)} >
              <span>Profession</span>
            </li>
            <li onClick={()=>setStep(4)} >
              <span>Ideal Client</span>
            </li>
            <li onClick={()=>setStep(5)} >
              <span>Good referral partners</span>
            </li>
            <li onClick={()=>setStep(6)} >
              <span>Date of birth</span>
            </li>
            <li onClick={()=>setStep(7)} class="active">
              <span>Communication channel</span>
            </li>
            <li onClick={()=>setStep(8)}>
              <span>Hobbies</span>
            </li>
            <li onClick={()=>setStep(9)}>
              <span>Submit</span>
            </li>
          </ul>
          <div class="step_for_mob">
            <p>
              <span>7</span> of 9
            </p>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default Step7;
